/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccessTokenDtoFromJSON, AccessTokenDtoToJSON, } from './AccessTokenDto';
/**
 * Check if a given object implements the MyAlbumIdRequestDto interface.
 */
export function instanceOfMyAlbumIdRequestDto(value) {
    if ((!('albumId' in value) && !('album_id' in value)) || (value['albumId'] === undefined && value['album_id'] === undefined))
        return false;
    if (!('limit' in value) || value['limit'] === undefined)
        return false;
    if (!('offset' in value) || value['offset'] === undefined)
        return false;
    return true;
}
export function MyAlbumIdRequestDtoFromJSON(json) {
    return MyAlbumIdRequestDtoFromJSONTyped(json, false);
}
export function MyAlbumIdRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'albumId': json['album_id'],
        'limit': json['limit'],
        'offset': json['offset'],
        'token': json['token'] == null ? undefined : AccessTokenDtoFromJSON(json['token']),
    };
}
export function MyAlbumIdRequestDtoToJSON(json) {
    return MyAlbumIdRequestDtoToJSONTyped(json, false);
}
export function MyAlbumIdRequestDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'album_id': value['albumId'],
        'limit': value['limit'],
        'offset': value['offset'],
        'token': AccessTokenDtoToJSON(value['token']),
    };
}
